<template>
  <div class="app-container">
    <list ref="list" :can-price="canPrice">
      <template slot="toolbar-right" v-if="canWrite">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <!-- <el-button type="info" @click="onPrintTemaplate">打印模板</el-button> -->
        <!-- <el-button type="primary" @click="onExport" >导出</el-button> -->
        <el-button type="primary" @click="onIssue">任务下发</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{ row }">
            <!-- <el-button v-if="canWrite && row.Status !== 2" @click="edit(row)" type="text">编辑</el-button> -->
            <el-button v-if="canReview" type="text" @click="edit(row)">查看</el-button>
            <el-button v-if="row.Status == 1" type="text" @click="onFinished(row, 2)">完结</el-button>
            <el-button v-if="row.Status == 2" type="text" @click="onFinished(row, 1)">取消完结</el-button>
            <!-- <el-button type="text" @click="onPrint(row)">打印</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import list from '@/components/production/ticketmanagement/materials/list'

export default {
  name: 'materials',
  mixins: [curdMixins],
  components: {
    list
  },
  data() {
    return {
      api: require('@/api/pr/prGetDocTask').default
    }
  },
  mounted() {},
  computed: {
    canWrite() {
      return this.$permission.canWrite()
    },
    canPrice() {
      return this.$permission.canPrice()
    },
    canReview() {
      return this.$permission.canReview()
    }
  },
  methods: {
    edit(row) {
      let id = row.DocId
      this.api.info(id).then(res => {
        if (res.Code === 0) {
          this.toURL({ name: 'editmaterials', params: { type: 'edit', data: res.Data } })
        }
      })
    },
    create() {
      this.toURL({
        name: 'editmaterials',
        params: { type: 'create' }
      })
    },
    toURL(o) {
      this.$router.push(o)
    },
    onPrintTemaplate() {
      var url = location.origin + '/#/customprint/' + '派工单'
      window.open(url, '_blank')
    },
    onPrint(row) {
      var url = location.origin + '/#/customprintview/派工单/' + row.DocId
      window.open(url, '_blank')
    },
    //Status：草稿 = 0，已下发 = 1，完结 = 2，取消完结 = 1
    onFinished(row, Status) {
      this.$confirm('确认是否完结或者取消完结？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const ids = [row.DocId]
          const o = { ids, Status }
          this.api.updateStatus(o).then(res => {
            if (res.Code === 0) {
              this.$message.success('操作成功')
              this.reload()
            } else {
              this.$message.error(res.Msg)
            }
          })
        })
        .catch(() => {})
    },
    onIssue() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要任务下发的数据')
        return
      }
      this.$confirm('确认是否任务下发所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => item.DocId)
          const o = { ids, Status: 1 }
          this.api.updateStatus(o).then(res => {
            if (res.Code == 0) {
              this.$message.success(res.Msg)
              this.reload()
            } else {
              this.$message.error(res.Msg)
            }
          })
        })
        .catch(() => {})
    },
    onExport() {
      this.$confirm('是否导出数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var loading = this.$loading({
            lock: true,
            text: '正在导出...',
            spinner: 'el-icon-loading',
            customClass: 'my_loading',
            background: 'rgba(0, 0, 0, 0.3)'
          })
          this.api.export(this.$refs.list.$refs.list.queryParams).then(res => {
            loading.close()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
